import {ErrorBoundary} from '@commercial-website/observability'
import {PrismicPreviewProvider} from 'gatsby-plugin-prismic-previews'
import React from 'react'
import type {ReactNode} from 'react'

import {LaunchDarklyProvider} from '@/feature-flags/launch-darkly'
import {GoogleReCaptchaProvider} from '@/providers/google-recaptcha'
import {ThemeProvider} from '@/providers/theme'

// Adds a shared React Context for Prismic preview sessions.
type WrapRootElementProps = {
    children: ReactNode
}
export const WrapRootElement = ({children}: WrapRootElementProps) => (
    <ErrorBoundary>
        <GoogleReCaptchaProvider reCaptchaKey={process.env.GATSBY_RECAPTCHA_V3_SITE_KEY!}>
            <PrismicPreviewProvider>
                <ThemeProvider>
                    <LaunchDarklyProvider
                        clientSideID={process.env.GATSBY_LAUNCH_DARKLY_CLIENT_ID!}
                        baseUrl={process.env.GATSBY_LAUNCH_DARKLY_BASE_URL}
                        streamUrl={process.env.GATSBY_LAUNCH_DARKLY_STREAM_URL}
                        eventsUrl={process.env.GATSBY_LAUNCH_DARKLY_EVENTS_URL}
                    >
                        {children}
                    </LaunchDarklyProvider>
                </ThemeProvider>
            </PrismicPreviewProvider>
        </GoogleReCaptchaProvider>
    </ErrorBoundary>
)
